import React from 'react'
import cta from '../../images/cta-s1-pic.jpg'
import { Link } from 'react-router-dom';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const CtaSection = (props) => {

    return (
        <section className="cta-s1-section">
            <div className="container">
                <div className="row">
                    <div className="col col-xl-5 col-lg-5 col-12">
                        <div className="img-holder">
                            <img src={cta} alt=""/>
                        </div>
                    </div>
                    <div className="col col-xl-6 offset-xl-1 col-lg-7 col-12">
                        <div className="info-col">
                            <div className="section-title">
                                <span>#Events Fundraising</span>
                                <h2>We will <span>togather</span> make the world better</h2>
                            </div>

                            <div className="details">
                                <p>At our core, we empower individuals and strengthen communities through education, mentorship, and compassionate support. Guided by our core values of integrity, respect, community, passion, and diversity, we are committed to creating opportunities that foster growth, resilience, and hope, ensuring no one faces life’s challenges alone.</p>
                                <Link onClick={ClickHandler} to="/contact" className="theme-btn-s6"><i className="fi flaticon-like"></i> Donate now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CtaSection;